import ProfileConfig from './ProfileConfig';

export default ProfileConfig;
